import { WavyDivider } from 'src/shared/design-system/WavyEdge';

export const PreCheckoutUpsellModalHeader = () => (
  <>
    <div className='text-center'>
      <h3 className='text-2xl font-bold'>Multiple shefs. One delivery.</h3>
      <p className='text-neutral-700'>
        Perfectly paired sides and appetizer
        <br />
        recommendations for{' '}
        <span className='relative font-bold'>
          no extra fee!
          <span className='absolute -bottom-1 -left-1 -z-10 box-content block h-2 w-full bg-kale-50 px-1' />
        </span>
      </p>
    </div>

    <div className='pb-8 pt-6'>
      <WavyDivider />
    </div>
  </>
);
